import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {EventsModelService} from '../../Models/Events/events-model.service';
import {EventStatusDto} from '../../../Models/Events/event-status.interface';
import {EventStatusEnum} from '../../../Shared/Enum/event-status.enum';

@Injectable({
  providedIn: 'root'
})
export class EventsApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    public model: EventsModelService,
  ) {
    super(injector);
  }


  /**
   * Obtener los eventos
   *
   */
  public getEvents(filters: { fecha_desde: string, fecha_hasta: string }, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('events/list', filters, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener el detalle del evento
   *
   */
  getEventDetail(eventId: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('event/' + eventId, {}, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Iniciar evento
   *
   */
  startEvent(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('event/start', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Empezar evento
   *
   */
  openEvent(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('event/progress', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Finalizar evento
   *
   */
  finishEvent(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('event/finish', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener los estados de un evento
   *
   */
  getEventStatus(): EventStatusDto[] {
    return [
      {
        id: EventStatusEnum.Confirmed,
        nombre: 'CONST.EVENT_STATUS.CONFIRMED'
      },
      {
        id: EventStatusEnum.Starting,
        nombre: 'CONST.EVENT_STATUS.STARTING'
      },
      {
        id: EventStatusEnum.Started,
        nombre: 'CONST.EVENT_STATUS.STARTED'
      },
      {
        id: EventStatusEnum.InProgress,
        nombre: 'CONST.EVENT_STATUS.IN_PROGRESS'
      },
    ];
  }

}
